module.exports = __webpack_public_path__ + "static/media/mod-travel.33dc58c6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/portfolio/mod-travel.jpg
// module id = 341
// module chunks = 0